import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from '@/components/design-system/radio-group';
import {
  FormControl,
  FormItem,
  FormLabel,
} from '@/components/design-system/Form';

interface Choice {
  recordValue: string;
  content: string;
  ordinal: number;
  errorMessage?: string | null;
}

interface ConsentRadioButtonProps {
  choices: Choice[];
  control: any;
  errorMessage: string | null;
  onErrorChange: (error: string | null) => void;
  onValidationChange: (isValid: boolean) => void;
  watchValue: any;
}

export const ConsentRadioButton = ({ 
  choices, 
  control, 
  errorMessage,
  onErrorChange,
  onValidationChange,
  watchValue
}: ConsentRadioButtonProps) => {
  useEffect(() => {
      const selectedChoice = choices.find(
        (c) => c.recordValue === watchValue,
      );
      const error = selectedChoice?.errorMessage || null;
      onErrorChange(error);
      onValidationChange(!error && !!watchValue);
  }, [watchValue, choices, onErrorChange, onValidationChange]);

  return (
    <div className="mt-8">
      <Controller
        name="consentChoice"
        control={control}
        render={({ field }) => (
          <RadioGroup
            onValueChange={field.onChange}
            value={field.value}
            className="flex items-center gap-x-6"
          >
            {choices.map((choice) => (
              <FormItem
                key={choice.recordValue}
                className="flex items-center gap-x-2"
              >
                <FormControl>
                  <RadioGroupItem
                    value={choice.recordValue}
                    id={choice.recordValue}
                  />
                </FormControl>
                <FormLabel
                  htmlFor={choice.recordValue}
                  className="text-sm font-medium leading-none !mt-0"
                >
                  {choice.content}
                </FormLabel>
              </FormItem>
            ))}
          </RadioGroup>
        )}
      />

      {errorMessage && (
        <p className="text-red-500 text-sm mt-4">{errorMessage}</p>
      )}
    </div>
  );
}; 